export enum SBAPages {
    business = "business",
    finance =  "finance",
    general= "general",
    ownership = "ownership",
    firstThankYou = "finish",
    documentation = "documentation",
    finalThankYou = "finalThankYou",
    loanCalculator = "loanCalculator"
}


// WEBPACK FOOTER //
// ./src/scenes/Forms/screens/FormSBA/FormSBASteps/SBATypes.ts